import type {
  DocumentAuditTrailModel,
  CourseCertificateEvidenceModel,
} from "@/api/cle-api";
import { DocumentAuditTrailAction } from "@/api/cle-api/models/documents";
import { CleApiErrorText } from "@/components/cle-api/CleApiErrorText";
import Spinner from "@/components/spinner/Spinner";
import { useMemo } from "react";

import { AuditTrailTimeline } from "./AuditTrailTimeline";

interface CourseCertificateAuditTrailProps {
  auditTrail: DocumentAuditTrailModel[];
  certificate: CourseCertificateEvidenceModel;
  error: Error | null;
  isLoading: boolean;
}

const buildAuditTrailEvents = (
  auditTrail: DocumentAuditTrailModel[],
  certificate: CourseCertificateEvidenceModel,
): DocumentAuditTrailModel[] => {
  if (auditTrail.length > 0) {
    return auditTrail;
  }

  return [
    {
      action: DocumentAuditTrailAction.UPLOADED,
      createdAt: certificate.createdAt,
      actorDisplayName: certificate.createdByUserName ?? undefined,
    },
  ];
};

export const CourseCertificateAuditTrail = ({
  auditTrail,
  certificate,
  error,
  isLoading,
}: CourseCertificateAuditTrailProps) => {
  const events = useMemo(
    () => buildAuditTrailEvents(auditTrail, certificate),
    [auditTrail, certificate],
  );

  return (
    <div className="c-card">
      <h3 className="mb-3">Aktivitetslog</h3>
      {isLoading && <Spinner label="Henter aktivitetslog ..." />}
      {error && (
        <CleApiErrorText
          error={error}
          fallback="Kunne ikke hente aktivitetslog."
          className="text-danger mb-0"
          as="p"
        />
      )}
      {!isLoading && !error && <AuditTrailTimeline events={events} />}
    </div>
  );
};
